import type { Session } from "@/repositories/authRepository";

/**
 * Where somebody belongs when they have not asked for anywhere in particular.
 *
 * SmartSpaza staff have no shop of their own, so the till is meaningless to
 * them: they belong in the admin portal — unless they are viewing a shop for
 * support, in which case that shop's dashboard. A personal account belongs in
 * the stokvel portal.
 */
export function homePathFor(session: Session | null): string {
  // A stokvel member who signed up from their phone has no shop and no till.
  if (session?.user.isPersonal) return "/stokvel";
  if (session?.user.isPlatformStaff) return session.supportView ? "/dashboard" : "/admin";
  return "/sales";
}
